import { FormControl, Validators, FormGroup, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { Component, ChangeDetectionStrategy, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import * as moment from 'moment';

import { AuditTrailRecordsStorage, AuditTrailRecordsFile } from './audit-trail-records-storage';
import { AuditTrailType } from './audit-trail-type';

@Component({
    selector: 'audit-trail-export',
    template: require('./audit-trail-export.component.html'),
    styles: [require('./audit-trail-export.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuditTrailExportComponent implements AfterViewInit {
    public readonly auditTypeCtrl: FormControl;
    public readonly fromDateCtrl: FormControl;
    public readonly toDateCtrl: FormControl;
    public readonly auditExportForm: FormGroup;
    public readonly auditItemsDictionary: { [key: number]: string };

    constructor(
        private auditTrailRecordsStorage: AuditTrailRecordsStorage,
        private changeDetectorRef: ChangeDetectorRef
    ) {
        this.auditTypeCtrl = new FormControl(0, Validators.required);
        this.fromDateCtrl = new FormControl(moment(), Validators.required);
        this.toDateCtrl = new FormControl(moment(), Validators.required);

        this.auditExportForm = new FormGroup(
            {
                'auditType': this.auditTypeCtrl,
                'fromDate': this.fromDateCtrl,
                'toDate': this.toDateCtrl
            },
            this.verifyDates());

        this.auditItemsDictionary = {
            [AuditTrailType.Announcements]: 'Announcements',
            [AuditTrailType.GeneralDocuments]: 'General Documents',
            [AuditTrailType.SiteCommunications]: 'Site Communications',
            [AuditTrailType.SiteActions]: 'Site Actions',
            [AuditTrailType.SponsorCommunications]: 'Sponsor Communications',
            [AuditTrailType.StudyDocuments]: 'Study Documents'
        };
    }

    public ngAfterViewInit(): void {
        setTimeout(() => this.changeDetectorRef.markForCheck(), 0);
    }

    public async download() {
        const file: AuditTrailRecordsFile = await this.getRecordsFile();

        if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file.data, file.filename);
        } else {
            const elem = document.createElement('a') as HTMLAnchorElement;
            elem.href = URL.createObjectURL(file.data);
            elem.download = file.filename;
            document.body.appendChild(elem);
            elem.click();
            document.body.removeChild(elem);
        }
    }

    private verifyDates(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const fromDate: moment.Moment = control.get('fromDate').value;
            const toDate: moment.Moment = control.get('toDate').value;

            if (!fromDate || !toDate) {
                return { emptyDate: {} };
            }

            return fromDate.isSameOrBefore(toDate, 'day') ? null : { wrongDateRange: {} };
        };
    }

    private getRecordsFile(): Promise<AuditTrailRecordsFile> {
        return this.auditTrailRecordsStorage.getRecordsCsvFile(
            this.auditTypeCtrl.value as number,
            this.fromDateCtrl.value as moment.Moment,
            this.toDateCtrl.value as moment.Moment
        ).toPromise<AuditTrailRecordsFile>();
    }
}